if (typeof Epidemia !== " function") {
  window.Epidemia = function (wrapper, duracion, formato) {
    let alto = formato == "horizontal" ? 1200 : 1000;
    let ancho = formato == "horizontal" ? 1600 : 500;
    let box = new Box({
      size: { width: ancho, height: alto },
      padding: 20,
    });

    let svg = null;
    let gMain = null;
    let gArrow = null;
    let gLines = null;
    let gNodes = null;
    let radio = 3;

    let data = {
      nodes: [
        {
          id: "1",
          name: "1",
          center: null,
          cont: 0,
          fx: 0,
          fy: 0,
        },
      ],
      links: [],
    };
    let simulation = null;

    let cont = 0;

    function setup() {
      //console.log(`Formato: ${formato}`);
      crearSVG(wrapper);
      crearCirculos();
      //console.dir(data);
      crearGrafo();
      crearScroller();
    }

    const debouncedHandleScroll = _.debounce(handleScroll, 200);
    let total = 0;

    function crearScroller() {
      //console.log("crearScroller");
      let parent = d3.select("#scroll");
      total = parent.node().scrollHeight - window.innerHeight;
      d3.select(window).on("scroll", debouncedHandleScroll);
    }

    function handleScroll() {
      let parent = d3.select("#scroll");
      let el = parent.select(".scroll__sticky");
      let topPos = el.node().offsetTop;
      //console.log(`total: ${total}`);
      //console.log(`topPos: ${topPos}`);
      gArrow.style("opacity", 0);
      if (0 <= topPos && topPos <= 400) {
        actualizarGrafo(0);
        gArrow.style("opacity", null);
      } else if (topPos <= 800) {
        actualizarGrafo(1);
      } else if (topPos <= 1200) {
        actualizarGrafo(2);
      } else {
        actualizarGrafo(3);
      }
    }

    function actualizarGrafo(i) {
      if (cont != i) {
        cont = i;
      }
      let p = d3.select("#bullet");
      //console.log(p);
      switch (cont) {
        case 0:
          p.html(
            "El primer diagnóstico se reportó de manera oficial el 19 de febrero de 2025, era una menor de cinco años, originaria de Estados Unidos, que se encontraba en la ciudad de Oaxaca, Oaxaca.",
          );
          break;
        case 1:
          p.html(
            "El problema: Si una persona infectada llega a una comunidad que no está vacunada puede contagiar de 12 a 18 que no sean inmunes.",
          );
          break;
        case 2:
          p.html(
            "Esta enfermedad viral creció de manera exponencial en el país. En mayo de 2025 llegó el mayor pico de contagios a México.",
          );
          break;
        case 3:
          p.html(
            "Un año después la epidemia llegó a todo el país y acumula más de siete mil casos.",
          );
          break;
        default:
          break;
      }

      let obj = { nodes: [], links: [] };
      obj.nodes = _.filter(data.nodes, function (d) {
        return d.cont <= cont;
      });
      obj.links = _.filter(data.links, function (d) {
        return d.cont <= cont;
      });
      //console.log("actualizarGrafo");
      //console.dir(obj);

      gLines
        .selectAll("line")
        .data(obj.links, (d) => d.index)
        .join("line");

      gNodes
        .selectAll("circle")
        .data(obj.nodes, (d) => d.id)
        .join("circle")
        .attr("r", radio)
        .attr("cx", 0)
        .attr("cy", 0);

      simulation.nodes(obj.nodes);
      simulation.force("link").links(obj.links);
      simulation.alpha(1);
      simulation.restart();
    }

    function crearCirculos() {
      let i = 1;
      let n = 3;
      let num = 18;

      for (i = 1; i <= n; i++) {
        let cont = i - 1;
        let j = 1;
        let nodos = _.filter(data.nodes, { cont: cont });
        _.each(nodos, function (nodo) {
          for (j = 1; j <= num; j++) {
            let id = `${nodo.id}-${j}`;
            data.nodes.push({
              id: id,
              name: id,
              center: nodo,
              cont: cont + 1,
            });
            data.links.push({ source: nodo.id, cont: cont + 1, target: id });
          }
        });
      }
    }

    function crearGrafo() {
      let obj = { nodes: [], links: [] };
      obj.nodes = _.filter(data.nodes, function (d) {
        return d.cont <= cont;
      });
      obj.links = _.filter(data.links, function (d) {
        return d.cont <= cont;
      });
      //console.log("crearGrafo");
      //console.dir(obj);

      simulation = d3
        .forceSimulation(obj.nodes)
        .alphaDecay(0.01)
        .force(
          "link",
          d3
            .forceLink(obj.links)
            .id((d) => d.id)
            .distance(30),
          //.strength(0.5),

          //cont
        )
        .force("charge", d3.forceManyBody().strength(-10))
        .force(
          "x",
          d3.forceX(function (d) {
            return 0;
            return _.isNull(d.center) ? 0 : d.center.x;
          }),
        )
        .force(
          "y",
          d3.forceY(function (d) {
            return 0;
            return _.isNull(d.center) ? 0 : d.center.y;
          }),
        )
        .force("collision", d3.forceCollide().radius(radio))
        .on("tick", tick);

      gLines
        .selectAll("line")
        .data(obj.links, (d) => d.index)
        .join("line");

      gNodes
        .selectAll("circle")
        .data(obj.nodes, (d) => d.id)
        .join("circle")
        .attr("r", radio);
    }

    function tick() {
      gLines
        .selectAll("line")
        .attr("x1", (d) => d.source.x)
        .attr("y1", (d) => d.source.y)
        .attr("x2", (d) => d.target.x)
        .attr("y2", (d) => d.target.y);

      gNodes
        .selectAll("circle")
        .attr("cx", (d) => d.x)
        .attr("cy", (d) => d.y);
    }

    function crearSVG(wrapper) {
      svg = wrapper
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", `0 0 ${box.width} ${box.height}`);

      let defs = svg.append("defs");

      let gradient = defs
        .append("linearGradient")
        .attr("id", "fadeGradient")
        .attr("x1", 0)
        .attr("x2", 0)
        .attr("y1", 0)
        .attr("y2", 1);

      gradient
        .append("stop")
        .attr("offset", "0%")
        .attr("stop-color", "white")
        .attr("stop-opacity", 0);

      gradient
        .append("stop")
        .attr("offset", "50%")
        .attr("stop-color", "white")
        .attr("stop-opacity", 0);

      gradient
        .append("stop")
        .attr("offset", "90%")
        .attr("stop-color", "white")
        .attr("stop-opacity", 0.8);

      gradient
        .append("stop")
        .attr("offset", "100%")
        .attr("stop-color", "white")
        .attr("stop-opacity", 1);

      defs
        .append("marker")
        .attr("id", "arrowhead")
        .attr("viewBox", "0 -5 10 10") // Defines the coordinate system for the marker
        .attr("refX", 5) // The x coordinate where the arrow is drawn on the line
        .attr("refY", 0) // The y coordinate where the arrow is drawn on the line
        .attr("markerWidth", 6)
        .attr("markerHeight", 6)
        .attr("orient", "auto") // Automatically rotates the arrow to match the line direction
        .append("svg:path")
        .attr("d", "M0,-5L10,0L0,5") // The path data for a simple triangle shape
        .style("fill", "#000");

      svg = svg.append("g");

      let rect = d3
        .select(svg.node().closest("svg"))
        .append("rect")
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", 1600)
        .attr("height", alto + 10)
        .attr("fill", "url(#fadeGradient)");

      svg = svg
        .append("g")
        .attr(
          "transform",
          `translate(${box.padding.left}, ${box.padding.top})`,
        );

      let divisor = formato == "horizontal" ? 3 : 2;
      gMain = svg
        .append("g")
        .attr("data-g", "gMain")
        .attr(
          "transform",
          `translate(${box.margin.left + box.content.width / 2}, ${box.margin.top + (box.content.height * 1) / divisor})`,
        );

      gLines = gMain
        .append("g")
        .attr("data-g", "gLines")
        .attr("stroke", "#999999")
        .attr("stroke-opacity", 0.4)
        .attr("stroke-width", 1);

      gNodes = gMain
        .append("g")
        .attr("data-g", "gNodes")
        .attr("stroke", "#ff0000")
        .attr("stroke-width", 1)
        .attr("fill", "#da7770");

      gArrow = gMain
        .append("g")
        .attr("data-g", "gNodes")
        .attr("stroke", "#000000")
        .attr("stroke-width", 2)
        .attr("fill", "#000000");

      gArrow
        .append("line")
        .attr("x1", 0)
        .attr("y1", -110)
        .attr("x2", 0)
        .attr("y2", -20)
        .style("stroke", "#000")
        .attr("stroke-width", 1.5)
        .attr("marker-end", "url(#arrowhead)");
    }

    setup();
  };
}
